import { DivFacetDetail, EdgeLengthDiv, Heading } from './style';
import FractionalPitchSlider from 'components/ManualToolModal/FractionalPitchSlider';
import { NORMAL_FACET_DEFAULT_PITCH } from '../../constants';
import PitchSlider from 'components/ManualToolModal/PitchSlider';
import FacetArea from '../FacetInputs/FacetAreaDetail';
import Azimuth from '../FacetInputs/FacetAzimuth';
import PitchValue from '../FacetInputs/FacetPitchDetail';

type FacetDetailCardProps = {
	active: boolean;
	facet: {
		konvaPolygonId: string;
		area: number | null;
		hullcoords: number[][];
		azimuthDeg: number | null;
		pitchDeg: number | null;
		groupSuffix: string;
		name?: string;
		edges?: EdgeData | null;
		prevPitchDeg?: number;
		label?: string;
	};
	onCardClick: (id: string, groupSuffix: string) => void
	onPitchValChange: (id: string, groupSuffix: string, value: number) => void;
	enablePitchEditing: boolean;
	roofUpdateQueryRunning?: boolean;
	showPitchInFraction: boolean;
	isEdited?: boolean;
}

export default function FacetDetailCard(props: FacetDetailCardProps) {
	const { facet, active, onCardClick, enablePitchEditing, onPitchValChange, roofUpdateQueryRunning, showPitchInFraction } = props;

	function handleCardClick() {
		onCardClick(facet.konvaPolygonId, facet.groupSuffix);
	}

	return (
		<DivFacetDetail className={`${props.active ? 'active ' : ''} ${props.isEdited ? 'edited' : ''}`} onClick={handleCardClick}>
			<Heading>{facet.label ?? 'N/A'}</Heading>
			<Azimuth azimuthDeg={facet.azimuthDeg} />
			<FacetArea area={facet.area} />
			{enablePitchEditing ? (
				showPitchInFraction ? (
					<FractionalPitchSlider
						pitch={facet.pitchDeg ?? NORMAL_FACET_DEFAULT_PITCH}
						active={!!props.active}
						onChange={(degree) => {
							onPitchValChange(facet.konvaPolygonId, facet.groupSuffix, degree);
						}}
						disabled={roofUpdateQueryRunning}
					/>
				) : (
					<PitchSlider
						pitch={facet.pitchDeg ?? NORMAL_FACET_DEFAULT_PITCH}
						active={!!props.active}
						onChange={(val) => {
							onPitchValChange(facet.konvaPolygonId, facet.groupSuffix, +val);
						}}
						disabled={roofUpdateQueryRunning}
					/>
				)
			) : (
				<PitchValue pitchDeg={facet.pitchDeg} showPitchInFraction={showPitchInFraction} /> 
			)}
		
		</DivFacetDetail>
	);
}

// function DisplayEdgeLengths({ edges }: { edges: EdgeData }) {
// 	const [isOpen, setisOpen] = useState<boolean>(false);

// 	return (<DivAttrDetail style={{ flexDirection: 'column', gap: '5px' }}>
// 		<AccordianTitle onClick={() => { console.log('test'); setisOpen(!isOpen); }}>
// 			Edge Lengths(ft.) <span>({Object.keys(edges).length})</span>
// 			{!isOpen ?
// 				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
// 					strokeWidth={1.5} stroke="currentColor" width={20} height={20}>
// 					<path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
// 				</svg>
// 				:
// 				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
// 					strokeWidth={1.5} stroke="currentColor" width={20} height={20}>
// 					<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
// 				</svg>}

// 		</AccordianTitle>
// 		{isOpen && (Object.values(edges)?.map((edge, index) => {
// 			return (
// 				<EdgeLengthDiv key={index}>
// 					{/* {`Edge ${index + 1}`}: <span>{(convertMetricToFeet(edge.length))}</span> */}
// 				</EdgeLengthDiv>);
// 		}))}
// 	</DivAttrDetail>);

// }